import React from 'react';
import { Link } from 'react-router-dom';
import { IPLTradeLogo } from '../components/Layout';
import { ArrowLeft } from 'lucide-react';

export default function DeclarationPage() {
  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg-primary)', padding: '2rem 1.5rem' }}>
      <div style={{ maxWidth: 720, margin: '0 auto' }}>

        <Link to="/" style={{ display: 'inline-flex', alignItems: 'center', gap: 6, color: 'var(--text-secondary)', textDecoration: 'none', fontSize: '0.85rem', marginBottom: '2rem' }}>
          <ArrowLeft size={15} /> Back to App
        </Link>

        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: '2rem' }}>
          <IPLTradeLogo size={40} />
          <div>
            <h1 style={{ fontFamily: 'var(--font-display)', fontSize: '1.8rem', fontWeight: 700, color: 'var(--text-primary)' }}>
              Legal Declaration
            </h1>
            <p style={{ color: 'var(--text-secondary)', fontSize: '0.85rem', marginTop: 2 }}>
              IPLTrade — Free Fantasy Stock Trading Platform
            </p>
          </div>
        </div>

        {[
          {
            title: '1. This is a free-to-play game',
            content: `IPLTrade is a completely free, skill-based fantasy sports gaming platform. 
No real money is required to register, participate, or play. Users are awarded virtual points (in-game currency) 
upon registration and use these points exclusively within the game. 
No monetary deposits, withdrawals, wagers, or financial transactions of any kind are involved at any stage of gameplay.`,
          },
          {
            title: '2. No gambling — no real money',
            content: `This platform does not constitute gambling, wagering, or betting in any form under Indian law 
or the laws of any jurisdiction. There is no "prize pool," no real-money reward, and no financial benefit 
that can be derived from playing. All points, scores, and leaderboard rankings exist solely within the 
game environment and have no monetary value whatsoever.`,
          },
          {
            title: '3. Skill-based game',
            content: `IPLTrade is a game of skill. Success depends on the user's knowledge of cricket, 
player performance, match conditions, and strategic portfolio management — not on chance or luck. 
Fantasy sports games involving skill are recognized as distinct from gambling in multiple jurisdictions, 
including under frameworks established by the Hon'ble Supreme Court of India.`,
          },
          {
            title: '4. Not affiliated with BCCI, IPL, or any team',
            content: `IPLTrade is an independent fan-made application. It is not affiliated with, 
endorsed by, or in any way officially connected to the Board of Control for Cricket in India (BCCI), 
the Indian Premier League (IPL), any IPL franchise, or any player, agent, or official. 
Player names and statistics are used for informational and entertainment purposes under fair use.`,
          },
          {
            title: '5. Data and privacy',
            content: `We do not collect or store sensitive financial information. User data (username, email, 
optional phone number) is stored securely and used solely to operate the game. We do not sell, rent, 
or share your data with third parties for marketing purposes. Phone numbers, if provided, are used 
only for optional OTP-based login authentication.`,
          },
          {
            title: '6. For entertainment purposes only',
            content: `This platform is provided purely for entertainment and educational purposes. 
It is designed to let cricket fans enjoy a simulated stock market experience based on IPL player 
performance — similar to fantasy sports in concept. No decisions made within the game should be 
construed as financial, investment, or sports-betting advice.`,
          },
          {
            title: '7. Age restriction',
            content: `This platform is intended for users who are 13 years of age or older. 
By registering and using this platform, you confirm that you meet this age requirement. 
Users under 18 are encouraged to obtain parental or guardian consent before participating.`,
          },
          {
            title: '8. Compliance with Indian IT laws',
            content: `This platform operates in compliance with the Information Technology Act, 2000 
(as amended) and applicable rules. Users are responsible for ensuring their use of this platform 
complies with the laws of their respective state or country. In particular, users in states where 
even skill-based fantasy games face regulatory uncertainty are advised to review applicable local laws.`,
          },
          {
            title: '9. Disclaimer of liability',
            content: `The platform is provided "as is" without warranties of any kind. The developer shall not 
be liable for any loss, inconvenience, or dispute arising from use of this platform, including but 
not limited to any disruption in service, inaccuracy of live data, or technical issues. 
All game outcomes are based on publicly available cricket statistics fetched from third-party APIs.`,
          },
          {
            title: '10. Contact for concerns',
            content: `If you have any legal concerns, compliance questions, or believe this platform 
violates any law or regulation, please contact the developer at ranjan1991basak@gmail.com before 
taking any other action. We are committed to full legal compliance and will cooperate in good faith 
with any legitimate inquiry.`,
          },
        ].map(section => (
          <div key={section.title} style={{ marginBottom: '1.75rem' }}>
            <h3 style={{ fontFamily: 'var(--font-display)', fontSize: '1.05rem', fontWeight: 600, color: 'var(--text-primary)', marginBottom: 8 }}>
              {section.title}
            </h3>
            <p style={{ fontSize: '0.87rem', color: 'var(--text-secondary)', lineHeight: 1.75 }}>
              {section.content}
            </p>
          </div>
        ))}

        <div style={{
          marginTop: '2rem', padding: '1.25rem', borderRadius: 10,
          background: 'rgba(16,185,129,0.06)', border: '1px solid rgba(16,185,129,0.2)',
        }}>
          <div style={{ fontWeight: 600, color: 'var(--green)', marginBottom: 6, fontSize: '0.9rem' }}>
            Summary
          </div>
          <p style={{ fontSize: '0.84rem', color: 'var(--text-secondary)', lineHeight: 1.65 }}>
            IPLTrade is a <strong style={{ color: 'var(--text-primary)' }}>100% free</strong>,{' '}
            <strong style={{ color: 'var(--text-primary)' }}>no real money</strong>,{' '}
            skill-based cricket fantasy trading game made for fun.
            It does not involve gambling, wagering, or any real financial transaction.
            Enjoy the game responsibly.
          </p>
        </div>

        <div style={{ marginTop: '2rem', fontSize: '0.75rem', color: 'var(--text-muted)', textAlign: 'center' }}>
          Last updated: March 2026 · IPLTrade · Contact: ranjan1991basak@gmail.com
        </div>
      </div>
    </div>
  );
}
